export default {
    feedList(state) {
        for (const index in state.feedList) {
            state.feedList[index] = { 
                ...state.feedList[index], 
                idCopyButtonText: "ID", 
                idCopyIconName: "file_copy",
                mainCatOptions: [], 
                subCatOptions: [], 
                detailCatOptions: []
            }
        }
        
        return state.feedList;
    },
    moderationReason(state) {
        return state.moderationReason;
    },
    commentHistory(state) {
        return state.commentHistory;
    },
    registeredSocialAccounts(state) {
        return state.registeredSocialAccounts;
    },
    repyDrafts(state) {
        return state.repyDrafts;
    },
    attachments(state) {
        return state.attachments;
    },
    feederHistory(state) {
        return state.feederHistory;
    },
    workspaceTags(state){
        return state.workspaceTags;
    },
    foxTaskTitles(state) {
        return state.foxTaskTitles;
    },
    foxReplytypes(state) {
        return state.foxReplytypes;
    },
    foxPreviousReply(state) {
        return state.foxPreviousReply;
    },
    foxCategories(state) {
        return state.foxCategories;
    },
    foxFeedbacks(state) {
        return state.foxFeedbacks;
    },
    foxChannels(state) {
        return state.foxChannels;
    },
    foxComments(state) {
        return state.foxComments;
    },
    foxPages(state) {
        return state.foxPages;
    },
    foxRelatedFeeds(state) {
        return state.foxRelatedFeeds;
    },
    foxGsmTypeOptions(state){
        return state.foxGsmTypeOptions;
    },
    foxData(state) {
        return state.foxData;
    },
    foxHistory(state) {
        return state.foxHistory;
    },
    emojiList(state) {
        return state.emojiList;
    },
    emojisIsEnabled(state){
        return state.emojisIsEnabled;
    },
    misspellList(state) {
        const listWithoutEmptyChar = [];

        for (const misspelledItem of state.misspellList) {
            if (misspelledItem) listWithoutEmptyChar.push(misspelledItem);
        }

        return listWithoutEmptyChar;
    },
    feedAnswers(state) {
        return state.feedAnswers;
    },
    dynamicsCountriesList(state) {
        return state.dynamicsCountries;
    },
    dynamicsRelatedFeedList(state) {
        return state.dynamicsRelatedFeeds;
    },
    dynamicsMainFeed(state) {
        return state.dynamicsMainFeed;
    },
    checkAnswerRules(state) {
        return state.checkAnswerRules;
    },
    answerAudit(state) {
        return state.answerAudit;
    },
    answerAuditEnabled(state) {
        return state.answerAuditEnabled;
    },
    cepDefition(state) {
        return state.cepDefinition;
    },
    feedAnswer(state) {
        return state.feedAnswer;
    },
    checkAnswerCount(state) {
        return state.checkAnswerCount;
    },
    checkAnswerCountCopyTable(state) {
        return state.checkAnswerCountCopyTable;
    },
    feedsToBeMasked(state) {
        return state.feedsToBeMasked;
    },
    feedsAlreadyMarkedForMasking(state) {
        return state.feedsAlreadyMarkedForMasking;
    },
    feedsCannotBeUnmasked(state) {
        return state.feedsCannotBeUnmasked;
    },
    totalHistoryCount(state) {
        return state.totalHistoryCount;
    },
    replySuggestions(state) {
        return state.replySuggestions;
    },
    selectedReplyText(state) {
        return state.selectedReplyText;
    },
    feedNotes(state) {
        return state.feedNotes;
    }
}